import {
  FormControl,
  InputLabel,
  MenuItem,
  Select,
  Grid,
  Typography,
  TextField,
  Checkbox,
  FormControlLabel,
} from '@material-ui/core';
import React from 'react';
import {useDispatch} from 'react-redux';
import './ProductRiders.sass';
import * as RI from 'ApplicationEntry/models/ProductsRiders/RiderInformation';

type FixedCodeRiderInformationProps = {
  changeRiderInformationAction: (amount: number, code: string, index: number) => void;
  riderInformation: RI.default;
  isDisabled?: ((code: string) => boolean) | boolean;
  title?: string;
  disableTitle?: boolean;
  identifier: string;
};

const FixedCodeRiderInformation = ({
  changeRiderInformationAction,
  riderInformation,
  isDisabled,
  title,
  identifier,
  disableTitle,
}: FixedCodeRiderInformationProps) => {
  const dispatch = useDispatch();
  const numberRiderCodes = riderInformation.riderData.length;
  const riderCodeList = riderInformation.riderData.slice(0, numberRiderCodes);
  const getSelectedRiderAmountValue = (index: number) => riderInformation.amounts.get(index);
  const getRiderColumns = (outerIndex: number, numberRiderCodes: number, riderCodeList: RI.RiderCode[]) => {
    const start = outerIndex * 4;
    const end = Math.min(outerIndex * 4 + 4, numberRiderCodes);

    let elements = [] as JSX.Element[];

    for (let i = start; i < end; i++) {
      if (!riderCodeList[i].hidden) {
        elements.push(displayRiderAmounts(riderCodeList[i], i));
      }
    }

    return elements;
  };
  const getRiderRows = (numberRiderCodes: number, riderCodeList: RI.RiderCode[]) => {
    let rowDivisionElements = [] as JSX.Element[];

    const rowCount = numberRiderCodes / 4;

    for (let i = 0; i < rowCount; i++) {
      const rowDivisionElement = (
        <Grid container spacing={4} key={`${identifier}-rider-row-${i}`}>
          {getRiderColumns(i, numberRiderCodes, riderCodeList)}
        </Grid>
      );

      rowDivisionElements.push(rowDivisionElement);
    }

    return rowDivisionElements;
  };
  const getHeader = (header: string) => {
    return (
      <Grid item xs={12}>
        <Typography variant="subtitle1" className="product-riders-section__sub-title">
          {header}
        </Typography>
      </Grid>
    );
  };
  const displayRiderAmounts = (rider: RI.RiderCode, index: number) => {
    return (
      <>
        <Grid item xs={12} md={3} key={`rider-${rider.code}-${index}`}>
          <FormControl
            variant="outlined"
            className="product-riders-section__policy-type__form__row--field"
            key={`amount-${rider.code}`}
          >
            <InputLabel
              shrink
              id={`rider-amount-label-${index}`}
              className={'product-riders-section__policy-type__form__row--label'}
            >
              {rider.controlType !== RI.ControlType.Boolean && (rider.displayName || rider.code)}
            </InputLabel>
            {rider.controlType === RI.ControlType.Collection || rider.controlType === undefined ? (
              rider.units.length === 0 ? (
                <TextField
                  id={`rider-code-${index}`}
                  variant="outlined"
                  margin="normal"
                  type="number"
                  value={
                    getSelectedRiderAmountValue(index) === undefined ||
                    getSelectedRiderAmountValue(index) === Number.NaN
                      ? ''
                      : getSelectedRiderAmountValue(index)
                  }
                  onChange={event =>
                    dispatch(
                      changeRiderInformationAction(
                        event.target.value === '' ? Number.NaN : Number(event.target.value),
                        rider.code,
                        index
                      )
                    )
                  }
                  disabled={
                    typeof isDisabled === 'boolean'
                      ? isDisabled
                      : isDisabled !== undefined
                      ? isDisabled(rider.code)
                      : false
                  }
                  inputProps={{
                    maxLength: 10,
                    min: 0,
                    max: 100,
                  }}
                />
              ) : (
                <Select
                  labelId={`label-rider-amount-${index}`}
                  id={`rider-amount-${index}`}
                  value={getSelectedRiderAmountValue(index) === undefined ? '' : getSelectedRiderAmountValue(index)}
                  onChange={event =>
                    dispatch(
                      changeRiderInformationAction(
                        event.target.value === '' ? Number.NaN : (event.target.value as number),
                        rider.code,
                        index
                      )
                    )
                  }
                  displayEmpty
                  disabled={
                    typeof isDisabled === 'boolean'
                      ? isDisabled
                      : isDisabled !== undefined
                      ? isDisabled(rider.code)
                      : false
                  }
                >
                  <MenuItem value="" key={`${identifier}-rider-amount-none`}>
                    None
                  </MenuItem>
                  {riderInformation.getAvailableRiderUnits(rider).map((unit: RI.RiderCodeUnit, index: number) => (
                    <MenuItem value={unit} key={`${identifier}-rider-amount-${index}`}>
                      {unit}
                    </MenuItem>
                  ))}
                </Select>
              )
            ) : rider.controlType === RI.ControlType.Boolean ? (
              <FormControlLabel
                className="product-riders-section__policy-type__form__row--label"
                control={
                  <Checkbox
                    checked={
                      getSelectedRiderAmountValue(index) !== undefined &&
                      getSelectedRiderAmountValue(index) !== Number.NaN
                    }
                    onChange={event =>
                      dispatch(changeRiderInformationAction(event.target.checked ? 1 : Number.NaN, rider.code, index))
                    }
                    name="checkedB"
                    color="secondary"
                  />
                }
                disabled={rider.disabled}
                label={<Typography>{rider.code}</Typography>}
              />
            ) : (
              <>Data Not Available</>
            )}
          </FormControl>
        </Grid>
      </>
    );
  };

  return (
    <div className="product-riders-section__riders">
      {!disableTitle ? getHeader(title && title !== '' ? title : 'Riders') : <></>}
      {getRiderRows(numberRiderCodes, riderCodeList)}
    </div>
  );
};

export default FixedCodeRiderInformation;
